import React from "react";
import Lottie from "lottie-react";
import { Box } from "@mui/material";
import LOTTIE_ERROR from "../assets/Error_Lottie.json";

const LottieError = () => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh", 
        width: "100vw", 
        overflow: "hidden",
      }}
    >
      <Lottie
        animationData={LOTTIE_ERROR}
        style={{
          width: "100%",
          maxWidth: "600px", 
          maxHeight: "600px", 
        }}
      />
    </Box>
  );
};

export default LottieError;
